var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "13px",
    viewBox: "0 0 52 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Project-Editor-4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5,2.16666667 C47.8898333,2.16666667 49.8333333,4.11016667 49.8333333,6.5 C49.8333333,8.88983333 47.8898333,10.8333333 45.5,10.8333333 L6.5,10.8333333 C4.11016667,10.8333333 2.16666667,8.88983333 2.16666667,6.5 C2.16666667,4.11016667 4.11016667,2.16666667 6.5,2.16666667 L45.5,2.16666667 Z M52,6.5 C52,2.90983333 49.0901667,0 45.5,0 L6.5,0 C2.90983333,0 0,2.90983333 0,6.5 C0,10.0901667 2.90983333,13 6.5,13 L45.5,13 C49.0901667,13 52,10.0901667 52,6.5 Z M32.5,4.33333333 L6.5,4.33333333 C5.304,4.33333333 4.33333333,5.304 4.33333333,6.5 C4.33333333,7.696 5.304,8.66666667 6.5,8.66666667 L32.5,8.66666667 C33.696,8.66666667 34.6666667,7.696 34.6666667,6.5 C34.6666667,5.304 33.696,4.33333333 32.5,4.33333333 Z",
    id: "Shape",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/Progress.408349cc.svg";
export { ForwardRef as ReactComponent };